import {Box, Grid, Skeleton} from '@mui/material';
import AppCard from 'main/core/AppCard';
import PropTypes from 'prop-types';

export const WidgetSkeleton = ({isTable = false}) => {
  return (
    <AppCard>
      <Box sx={{p: 5}}>
        {/* Title/Header area */}
        <Skeleton variant='text' width='40%' height={40} sx={{mb: 4}} />

        {isTable ? (
          // Table-style skeleton (rows)
          <Box>
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} variant='text' height={35} sx={{mb: 1}} />
            ))}
          </Box>
        ) : (
          // Form-style skeleton (fields)
          <Grid container spacing={4}>
            {[1, 2, 3, 4].map((i) => (
              <Grid item xs={12} md={6} key={i}>
                <Skeleton variant='text' width='30%' />
                <Skeleton
                  variant='rectangular'
                  height={50}
                  sx={{borderRadius: 1}}
                />
              </Grid>
            ))}
            <Grid item xs={12}>
              <Box sx={{display: 'flex', justifyContent: 'flex-end', mt: 2}}>
                <Skeleton variant='rectangular' width={100} height={40} />
              </Box>
            </Grid>
          </Grid>
        )}
      </Box>
    </AppCard>
  );
};

WidgetSkeleton.propTypes = {
  isTable: PropTypes.bool,
};
